// Refactored permission/notification logic into a custom hook
import { useEffect, useState } from 'react';
import { CustomOptions, CommentUsersType } from 'types';
import { selectAllOption } from 'app-constants';

export function useCommentPermissions(commentUsers: CommentUsersType) {
  const [permissionOptions, setPermissionOptions] = useState<CustomOptions>([]);
  const [notifyOptions, setNotifyOptions] = useState<CustomOptions>([]);
  const [permittedUsers, setPermittedUsers] = useState<string[]>([selectAllOption.value]);
  const [notifiedUsers, setNotifiedUsers] = useState<string[]>([]);

  useEffect(() => {
    const options = Object.entries(commentUsers)
      .filter(([_key, user]) => !user.self)
      .map(([_key, user]) => ({
        label: user.name || user.email,
        value: user.email,
        avatar: user.avatar,
        role: user.role,
      }));
    setPermissionOptions(options);
  }, [commentUsers]);

  useEffect(() => {
    if (permissionOptions.length) {
      if (permittedUsers.includes(selectAllOption.value)) {
        setNotifyOptions(permissionOptions);
      } else {
        setNotifyOptions(permissionOptions.filter((opt) => permittedUsers.includes(opt.value)));
      }

      if (permittedUsers.length && !permittedUsers.includes(selectAllOption.value)) {
        setNotifiedUsers((prev) => prev.filter((user) => permittedUsers.includes(user)));
      }
    }
  }, [permittedUsers, permissionOptions]);

  return {
    permissionOptions,
    notifyOptions,
    permittedUsers,
    setPermittedUsers,
    notifiedUsers,
    setNotifiedUsers,
  };
}
